import React from 'react';
import { NIcon } from '@innersource-nn/novoui-react';

interface CardProps {
    title: string;
    subtitle: string;
    onClick: () => void;
}
// TODO: REPLACE WITH NCARD WHEN IS AVAILABLE
const SmallCard = ({ title, subtitle, onClick }: CardProps) => {
    return (
        <div
            onClick={onClick}
            className="bg-white justify-between items-center text-sm shadow-md flex text-true-blue p-12 rounded-8 cursor-pointer focus:ring focus:ring-light-blue-400 hover:shadow-2xl group relative hover:overflow-auto"
        >
            <div className="block">
                <b> {title}</b>
                <p className="text-faded-blue-600">{subtitle}</p>
            </div>
            <NIcon
                className="fill-faded-blue-600"
                iconName="chevronRight"
                size="normal"
            />
        </div>
    );
};

export default SmallCard;
